import { FourPropertyStatus } from '@/enums';
import { FourProperty } from '@/hooks/four/useFourProperties';

export const isPropertyAvailable = (property: FourProperty) =>
    property?.statusText && property?.statusText === FourPropertyStatus.AVAILABLE;
